define('audio/display',['require','exports','module','knockout','api-access','i18next','api-access','lodash'],function (require, exports, module) {
    var ko = require('knockout');
    var numbersApi = require('api-access').numbers;
    var i18n = require('i18next');
    var meetingsApi = require('api-access').meetings;
    var _ = require('lodash');

    function display() {
        var self = this;

        self.countries = ko.observableArray();
        self.accessCode = ko.observable();
        self.audioType = ko.observable();
        self.meetingName = ko.observable();
        self.search = ko.observable('');

        // E.g. 'US' -> 'United States'
        self.fullCountryName = function (code) {
            return i18n.t('countries.' + code);
        };

        self.getNumbersByCountry = function (data) {
            var newCountriesArray = [];
            if (data.phoneNumbers) {
                var countries = _.groupBy(data.phoneNumbers, 'country');
                _.each(countries, function (country) {
                    var countryObj = [];
                    countryObj.countryName = self.fullCountryName(country[0].country);
                    _.each(country, function (number) {
                        if (number.tollFree) {
                            countryObj.tollFreeNumber = number.displayNumber;
                        } else if (!number.tollFree) {
                            countryObj.tollNumber = number.displayNumber;
                        }
                    });

                    if (!countryObj.tollFreeNumber) {
                        countryObj.tollFreeNumber = '-';
                    }
                    if (!countryObj.tollNumber) {
                        countryObj.tollNumber = '-';
                    }
                    newCountriesArray.push(countryObj);
                });

                return newCountriesArray;
            }
            return undefined;
        };

        self.getMeeting = function (meetingId) {
            meetingsApi.byIdNoAuth(meetingId, true)
                .then(function (data) {
                    self.meetingName(data.subject);
                });
        };

        self.activate = function (meetingId) {
            self.getMeeting(meetingId);
            return numbersApi.primaries(meetingId)
                .then(function (data) {
                    self.audioType(data.audioType);
                    if (data.phoneNumbers) {
                        self.countries(self.getNumbersByCountry(data));
                        self.accessCode(data.accessCode);
                    }
                })
                .fail(function () {
                    window.location = '/pageNotFound';
                });
        };
    }

    module.exports = display;
});

